import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class SkuService {

  constructor(private http: HttpClient) { }

  getSkus(): Observable<any> {
    return this.http
      .get(
        `/api/v1/sku`
      );
  }

}



// WEBPACK FOOTER //
// ./client/app/services/sku.service.ts